module.exports = __webpack_public_path__ + "img/museum.3ec6b887.svg";